import { render, staticRenderFns } from "./Hatchery.vue?vue&type=template&id=0fd581fc&"
import script from "./Hatchery.vue?vue&type=script&lang=js&"
export * from "./Hatchery.vue?vue&type=script&lang=js&"
import style0 from "./Hatchery.vue?vue&type=style&index=0&id=0fd581fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports